import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { DebugItemContainer } from './debugItemContainer';
/**
 * Provides a "real time" view of a debug stat by polling it on an interval.
 */
export const RealTimeDebugItemContainer = ({ title, valueFn }) => {
    const [value, setValue] = useState(valueFn());
    const isMounted = useMountedState();
    useEffect(() => {
        const renderIntervalId = setInterval(() => {
            if (isMounted()) {
                setValue(valueFn());
            }
        }, 250);
        return () => {
            clearInterval(renderIntervalId);
        };
    }, [isMounted, valueFn]);
    return _jsx(DebugItemContainer, { title: title, value: value });
};
